export type AppTheme = 'light' | 'dark';

// UTAGE opens in its light look by default, whatever Telegram or the phone uses.
// Players can switch to dark in Profile; the choice is remembered on this device.
const STORAGE_KEY = 'utage.theme';
const CHROME: Record<AppTheme, string> = { light: '#f5f4f0', dark: '#111214' };
let current: AppTheme = 'light';

const readStored = (): string | null => { try { return localStorage.getItem(STORAGE_KEY); } catch { return null; } };
const writeStored = (theme: AppTheme): void => { try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* storage can be blocked; the choice still applies for this visit */ } };

/** Paints Telegram's header, background and bottom bar to match the app theme. */
export const syncTelegramChrome = (): void => {
  const webApp = window.Telegram?.WebApp;
  if (!webApp) return;
  const color = CHROME[current];
  const supports = (version: string): boolean => !webApp.isVersionAtLeast || webApp.isVersionAtLeast(version);
  try {
    if (supports('6.1')) { webApp.setHeaderColor?.(color); webApp.setBackgroundColor?.(color); }
    if (supports('7.10')) webApp.setBottomBarColor?.(color);
  } catch { /* older clients ignore colour changes */ }
};

const apply = (theme: AppTheme): void => {
  current = theme;
  const root = document.documentElement;
  root.dataset.appTheme = theme;
  root.style.colorScheme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', CHROME[theme]);
  syncTelegramChrome();
};

export const getAppTheme = (): AppTheme => current;
export const setAppTheme = (theme: AppTheme): void => { writeStored(theme); apply(theme); };
export const restoreAppTheme = (): AppTheme => { apply(readStored() === 'dark' ? 'dark' : 'light'); return current; };
